import { get } from "lodash";
import React from "react";
import { AddToolTip, WithDrawalCard } from "../../../components";
import {
  distributionFormFields,
  manageDistributionFormNames,
  maskedBankAccountNumberNormalizer,
  OPTIONS_DATA_MAPPER,
  ssnMasking,
} from "../../../utils";
import {
  DISTRIBUTION_WITHDRAWAL_MODE,
  getAddressDisplay,
  getFullName,
  getValues,
} from "../WithdrawalRequestContainer/DistributionConstantsAndFunctions";
import HeadingAndTextComponent from "../WithdrawalRequestContainer/HeadingAndTextComponent";

function WithdrawalAllocationCard(props) {
  const {
    withdrawalTransactionData,
    filteredValues,
    beneficiaryDetails,
    style = {},
    ...rest
  } = props;
  const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
  const fields = distributionFormFields[formName];
  const getDistributionModeName = () => {
    if (
      withdrawalTransactionData[fields.distributionMode] ===
      DISTRIBUTION_WITHDRAWAL_MODE.self
    ) {
      return getFullName(filteredValues);
    } else if (
      withdrawalTransactionData[fields.distributionMode] ===
      DISTRIBUTION_WITHDRAWAL_MODE.beneficiary
    ) {
      return (
        beneficiaryDetails.find(
          (_) => _.id == withdrawalTransactionData[fields.beneficiaryId]
        )?.name ?? ""
      );
    } else {
      return get(withdrawalTransactionData, "trusteeName", "");
    }
  };

  const getSlicedDistributionModeName = () => {
    const distributionModeName = getDistributionModeName();
    if (distributionModeName.length > 10) {
      return (
        <AddToolTip name={distributionModeName}>
          {(distributionModeName || "").slice(0, 10)}
          ...
        </AddToolTip>
      );
    } else {
      return <>{distributionModeName}</>;
    }
  };
  return (
    <WithDrawalCard style={4} cssStyle={style}>
      <HeadingAndTextComponent
        headingText={
          OPTIONS_DATA_MAPPER.DISTRIBUTION_MODES[
            withdrawalTransactionData[fields.distributionMode]
          ]
        }
        contentText={getSlicedDistributionModeName()}
      />
      <div style={{ marginLeft: "50px" }}>
        <HeadingAndTextComponent
          headingText="Payment Method"
          contentText={
            get(withdrawalTransactionData, "paymentMethod", "") === 2
              ? "Eft"
              : "Check"
          }
        />
      </div>
      <div style={{ marginLeft: "50px" }}>
        {get(withdrawalTransactionData, "paymentMethod", "") === 1 ? (
          <HeadingAndTextComponent
            headingText="Address"
            contentText={getAddressDisplay(
              get(withdrawalTransactionData, "address", "")
            )}
          />
        ) : (
          <HeadingAndTextComponent
            headingText="Account Number"
            contentText={get(
              withdrawalTransactionData,
              "bankInformation.checkingSavingsAccountNumber",
              ""
            ).toString()}
          />
        )}
      </div>
      <div class="vertical-line-withdrawal-allocation"> </div>
      <div style={{ marginLeft: "50px" }}>
        <HeadingAndTextComponent
          headingText="Amount"
          contentText={getValues(
            get(withdrawalTransactionData, "requestedAmount", "")
          ).toFixed(2)}
        />
      </div>
    </WithDrawalCard>
  );
}

export default WithdrawalAllocationCard;
